__turbopack_context__.v({
  "add-on-text": "product-interest-module__DsdjJa__add-on-text",
  "additionals-delimiter": "product-interest-module__DsdjJa__additionals-delimiter",
  "checkbox-card": "product-interest-module__DsdjJa__checkbox-card",
  "error-message": "product-interest-module__DsdjJa__error-message",
  "form": "product-interest-module__DsdjJa__form",
});
